// src/components/WebFloatingActionButton.js
import React, { useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';

const FloatingActionButton = ({ onAddExpense, onAddIncome, isOpen, setIsOpen, user }) => {
    const quickAddItems = [
        {
            title: 'Add Expense',
            emoji: '💳',
            color: '#dc2626', // expense color
            onPress: onAddExpense
        },
        {
            title: 'Add Income',
            emoji: '💰',
            color: '#10b981', // income color
            onPress: onAddIncome
        }
    ];

    const handleQuickAdd = (item) => {
        item.onPress();
        setIsOpen(false);
    };

    const handleToggleMenu = () => {
        if(user){
            setIsOpen(!isOpen);
        }
    };

    // Close menu if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && !event.target.closest('.fab-container')) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isOpen, setIsOpen]);

    return (
        <div className="fab-container" style={styles.container}>
            {isOpen && (
                <div style={styles.optionContainer}>
                    {quickAddItems.map((item, index) => (
                        <button
                            key={index}
                            style={{
                                ...styles.option,
                                backgroundColor: theme.backgroundColor,
                                borderColor: item.color
                            }}
                            onClick={() => handleQuickAdd(item)}
                        >
                            <div style={styles.optionContent}>
                                <span style={styles.optionEmoji}>{item.emoji}</span>
                                <span style={{
                                    ...styles.optionText,
                                    color: '#333'
                                }}>
                                    {item.title}
                                </span>
                            </div>
                        </button>
                    ))}
                </div>
            )}
            
          <button
                style={{
                    ...styles.button,
                    backgroundColor: '#3b82f6', // Balance color
                    transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
                }}
                onClick={handleToggleMenu}
                disabled={!user}
            >
                <span style={styles.buttonIcon}>+</span>
            </button>
          
        </div>
    );
};

const styles = {
    container: {
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        zIndex: 1000
    },
    button: {
        width: '48px',
        height: '48px',
        borderRadius: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'none',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        cursor: 'pointer',
        transition: 'transform 0.3s ease',
        color: 'white',
        fontSize: '24px',
        fontWeight: 'bold'
    },
    buttonIcon: {
        fontSize: '24px',
        lineHeight: '24px'
    },
    optionContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginBottom: '10px',
        animation: 'fadeIn 0.3s ease-out'
    },
    option: {
        padding: '10px 15px',
        borderRadius: '20px',
        marginBottom: '10px',
        minWidth: '130px',
        border: '1px solid',
        background: 'white',
        cursor: 'pointer',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        animation: 'slideUp 0.3s ease-out'
    },
    optionContent: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    optionEmoji: {
        fontSize: '16px'
    },
    optionText: {
        fontSize: '15px',
        fontWeight: '500'
    }
};

// Add CSS animations to the document
const addAnimationsToHead = () => {
    if (!document.getElementById('fab-animations')) {
        const styleSheet = document.createElement('style');
        styleSheet.id = 'fab-animations';
        styleSheet.textContent = `
            @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
            }
            @keyframes slideUp {
                from { 
                    opacity: 0;
                    transform: translateY(20px);
                }
                to { 
                    opacity: 1;
                    transform: translateY(0);
                }
            }
        `;
        document.head.appendChild(styleSheet);
    }
};

// Call the function to add animations
if (typeof window !== 'undefined') {
    addAnimationsToHead();
}

export default FloatingActionButton